module.exports = __webpack_public_path__ + "static/media/campana-b1.c3d94130.png";